import React from 'react'
import { connect } from 'react-redux'
import StatusHistory from './StatusHistory'
import {
    ajaxAssignEmployee,
    ajaxBlockUser,
    ajaxMaskedCall,
    getStarsJSX,
    setLoading,
    updateModalContent,
    warnNoChat
} from '../redux/FeedbackRedux'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import Alert from '../Alert'
import Smiley from '../Smiley'
import ForwardHistory from '../feedbackdetail/ForwardHistory'
import moment from 'moment-timezone'
import { highlightAlertKeywords } from '../helpers/highlightAlertKeywords'

class FeedbackSection extends React.Component {
    constructor(props) {
        super(props);
        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
        this.handleBlockClick = this.handleBlockClick.bind(this);
        this.handleMaskedCallClick = this.handleMaskedCallClick.bind(this);
        this.handleRatingPageEmployeeClick = this.handleRatingPageEmployeeClick.bind(this);
    }

    handleClick(event) {
        event.preventDefault();
        if (this.props.feedback.is_include_contact) {
            window.scrollTo(0, document.body.scrollHeight);
            document.getElementById('chat-textarea').focus();
            document.getElementById('chat-textarea').select();
        } else {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
        }
    }

    handleRatingPageEmployeeClick(event) {
        event.preventDefault();
        const modal_id = "assignRatingPageEmployeeModal";
        const modal_title = __("Change the Associated Employee");
        const modal_body = "renderAssignRatingPageEmployee";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel"); // this.props.onClose
        const button_2_class = "primary";
        const button_2_id = "assignRatingPageEmployee";
        const button_2_text = __("Save"); // this.handleSave
        const selectedRatingPageEmployeeId = event.currentTarget.getAttribute('data-rating-page-employee-id');

        this.props.dispatch(updateModalContent({
            modal_id: modal_id,
            modal_title: modal_title,
            modal_body: modal_body,
            button_1_class: button_1_class,
            button_1_id: button_1_id,
            button_1_text: button_1_text,
            button_2_class: button_2_class,
            button_2_id: button_2_id,
            button_2_text: button_2_text,
            selectedRatingPageEmployeeId: selectedRatingPageEmployeeId ? parseInt(selectedRatingPageEmployeeId) : null
        }));
        jQuery('.modal:not(.error)').modal();
    }

    handleDepartmentClick(department_id, event) {
        if (this.props.feedback.department_id !== department_id) {
            const modal_id = "departmentModal";
            const modal_title = __("Update Feedback's Department");
            const modal_body = "You are updating the department of this Feedback from " + this.props.feedback.department.name + " to " + jQuery('.department-drop#' + department_id).text() + ". Would you like the employees (who normally receive new Feedback notifications for the " + jQuery('.department-drop#' + department_id).text() + " department) to receive notifications about this update?"
            const button_1_class = "outline-secondary";
            const button_1_id = "sendQuiet";
            const button_1_text = __("No, update quietly");
            const button_2_class = "primary";
            const button_2_id = "sendLoud";
            const button_2_text = __("Yes, send notifications");
            window.findDepartment = department_id;
            this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
            jQuery('.modal:not(.error)').modal();
        }
        event.preventDefault();
    }

    handleBlockClick(event) {
        event.preventDefault();
        this.props.dispatch(ajaxBlockUser(this.props.feedback.business_id, this.props.feedback.feedback_id));
    }

    handleMaskedCallClick(event) {
        this.props.dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
        this.props.dispatch(ajaxMaskedCall(this.props.feedback.feedback_id));
    }

    handleAssignEmployee(employee, event) {
        event.preventDefault();
        if (this.props.feedback.assigned_to !== employee) {
            this.props.dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
            this.props.dispatch(ajaxAssignEmployee(this.props.feedback.feedback_id, employee));
        }
    }

    feedbackTitle () {
        let title = '<b>Feedback</b>'
        if (this.props.feedback.is_emp) {
            title += ` <b>(Sent By Employee)</b>`
        }
        if (this.props.feedback.access_method === 'URL') {
            title += ` <span>(Visited ${this.props.feedback.friendly_access_url})</span>`
        }
        if (this.props.feedback.access_method === 'QR Code' && this.props.feedback.custom_qr_code) {
            title += ` <span>(Scanned QR Code "${this.props.feedback.custom_qr_code.name}")</span>`
        }
        if (this.props.feedback.access_method === 'QR Code' && !this.props.feedback.custom_qr_code) {
            title += ` <span>(Scanned Main QR Code)</span>`
        }
        if (this.props.feedback.access_method === 'ContactUs') {
            title += ` <span>(Contact Us)</span>`
        }
        if (this.props.feedback.access_method === 'App') {
            title += ` <span>(Mobile App)</span>`
        }
        if (this.props.feedback.access_method === 'AutoPilot SMS') {
            title += ` <span>(AutoPilot Rating Request Link)</span>`
        }
        title += ':'

        return title
    }

    render() {
        //requested via list
        // this is used for highlighting the search letters
        if (this.props.state.red_alerts_list) {
            var keywords = this.props.state.red_alerts_list;
            if (keywords) {
                var feedback_red_text = highlightAlertKeywords(this.props.feedback.description, keywords);
            }
        }

        let titleClass = this.props.feedback.priority === 30 ? 'text-priority-30' : 'text-primary';
        const regex = new RegExp(this.props.state.query, "gi");

        // info needed for top extras blocks
        let feedbackObj = this.props.feedback;

        // stars
        let stars = getStarsJSX(feedbackObj.ratethisbizrating?.rating ?? 1, "OTF", true);
        // rating and smiley - data-withstars={false} intentionally added. @todo: check if it's needed
        const smileyRating =
            <div className="feedback-rating-satisfaction-wrapper" data-withstars={false}>
				{this.props.feedback.smiley_score !== null &&
					<div style={{ "lineHeight": "20px" }} className="align-items-center d-flex ml-1">
						<span data-toggle="tooltip" data-placement="top" data-title={__('A Feedback\'s smiley rating is chosen by the Feedbacker when they submit the Feedback. The ratings are color-coded as follows unhappiest to happiest:') + ": <img src='/img/feedback-smiley-rating-scale.png' style='width:100%; border-radius: 5px;' />"} >
							<Smiley is_feedback_detail={true} smiley_score={feedbackObj.smiley_score} secondMode />
						</span>
					</div>
				}
				<div className="feedback-stars-rating ml-1">
					{feedbackObj.ratethisbizrating?.rating > 0 &&
						<>
							<span>{__("Rating")}:&nbsp; {stars}&nbsp;{feedbackObj.ratethisbizrating.rating}/5</span>
							<i className="far fa-question-circle text-muted ml-1 mr-2" data-toggle="tooltip" data-placement="top" data-title={"This is the star rating submitted by the customer after receiving the 1Thru5 Link. This is a private site owned by Feedback and this rating is not made public."}></i>
						</>
					}
				</div>
            </div>;

        return (
            <>
                <div className={`col-12 feedback-message-container ${this.props.feedback?.extra_details ? 'has-extra-details' : ''}`}>
                    {/* top row */}
                    <div className='row pt-2 pb-2 justify-content-start'>
                        {/* top left details */}
                        <div className='feedback-extras-block feedback-extras-block--left'>
                            {/* Rating Submmited */}
							<div className='feedback-rating-submitted'>
								<h6>
									{ __('Satisfaction') }:
								</h6>
                            	{(this.props.feedback.rating !== null || this.props.feedback.smiley_score !== null)
									? smileyRating
									: <span className='ml-2'>-</span>
                            	}
							</div>

                            {/* Submitted Through */}
                            <h6>
                                { __('Submitted Through') }:&nbsp;
                                {this.props.feedback.referrer.link ? <><span>{this.props.feedback.referrer.label}</span>&nbsp;-&nbsp;<a href={this.props.feedback.referrer.link.url} target="_blank">{this.props.feedback.referrer.link.label}</a></> : <span>{this.props.feedback.referrer.label}</span>}
                            </h6>

                            {this.props.feedback?.extra_details && this.props.feedback?.extra_details.length > 0 &&
                                <div className='feedback-extras-element'>
                                    <h6>{ __('Additional Info') }:</h6>
                                    {this.props.feedback.extra_details.map((el, index) => (
                                        <span key={index} className='feedback-extras-element-badge'>{el.field}: {el.value}</span>
                                    ))}
                                </div>}
                        </div>

                        {/* top right details */}
                        <div className='feedback-extras-block feedback-extras-block--right'>
                            {/* Submitted internally */}
                            {(this.props.feedback?.is_internal > 0 &&
                                <h6 className='mb-0'>{__('Submitted Internally')}</h6>
                            )}

                            {/* Submitted by */}
                            {(this.props.feedback.internal_submitted_by &&
                                <div className="d-flex align-items-end pl-0 mr-3">
                                    <p className="d-inline-block">
                                        <span>{__('Submitted By')}:</span>
                                        <span className="text-muted text-capitalize">{this.props.feedback.internal_user.firstname ? this.props.feedback.internal_user.firstname : "Anonymous"} {this.props.feedback.internal_user.lastname ? this.props.feedback.internal_user.lastname : ""}</span>

                                        {this.props.feedback.internal_user.title
                                            ?
                                            <span className="ml-1 text-muted">({this.props.feedback.internal_user.title})</span>
                                            :
                                            null
                                        }

                                        {this.props.feedback.internal_user.email
                                            ?
                                            <a href={"mailto:" + this.props.feedback.internal_user.email} className="ml-1 text-primary">{this.props.feedback.internal_user.email}</a>
                                            :
                                            null
                                        }

                                        {this.props.feedback.internal_user.phone
                                            ?
                                            <a href={"tel:" + this.props.feedback.internal_user.phone} className="ml-1 text-primary">{parsePhoneNumberFromString(this.props.feedback.internal_user.phone).format("NATIONAL")}</a>
                                            :
                                            null
                                        }
                                    </p>
                                </div>
                            )}

                            {/* Associated Employee section (only feedback created from a rating page can carry one) */}
                            {this.props.feedback?.rating_page_id ? (
                                <h6 className="mb-0" data-rating-page-employee-id={this.props.feedback?.ratingPageEmployee?.id}
                                    onClick={ (event) => { window.hasManageAccess ? this.handleRatingPageEmployeeClick(event) : null} }>
                                    {__('Associated Employee')}:
                                    &nbsp;
                                    <span>
                                        {this.props.feedback?.ratingPageEmployee?.name || 'None'}
                                        {window.hasManageAccess &&
                                            <span className="dropdown-toggle cursor-pointer pl-2"/>}
                                    </span>
                                </h6>
                            ) : null}

                            {/* Seen by section */}
                            {this.props.feedback.reads.length >= 0 &&
                                <div className="dropdown seen-by w-auto">
									<span className="dropdown-toggle pb-0 pt-0 pl-0 pr-1" id="dropdownMenuButton"
                                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<span className='seen-by'>{__('Seen By')}:</span>&nbsp;{this.props.feedback.reads.length}
									</span>

                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        {this.props.feedback.reads.map((value, index) => {
                                            return <div className="dropdown-item" key={index} id={value.id} ref="#">{value.display_name} - {value.created_at}</div>
                                        })
                                        }
                                    </div>
                                </div>
                            }

                            {/* Forward History */}
                            <ForwardHistory />
                        </div>
                    </div>

                    <div className="card-body feedback-message">
                        <Alert alert={this.props.state.alert.alert} location={'status'} />

                        <div className="d-flex flex-column d-xl-block row align-items-center">
                            <StatusHistory tz={this.props.feedback?.business?.call_at_timezone} />
                            {/* Feedback */}
                            <div className="col-md-12 col special-font">
                                {feedback_red_text ?
                                    <h3 className={`mb-0 font-weight-normal ${titleClass}`} dangerouslySetInnerHTML={{
                                        __html: feedback_red_text.replace(
                                            regex,
                                            '<span class="highlighted">$&</span>'
                                        )
                                    }}></h3>
                                    :
                                    <h3 className={`font-weight-normal ${titleClass}`}>
                                        { this.props.feedback.description
                                            ? this.props.feedback.description
                                            : (this.props.feedback?.custom_qr_code?.custom_qr_form_id ?
                                                <i>{__('This user has submitted a form')}</i> :
                                                <i>{__('This user only left a rating')}</i>)
                                        }
                                    </h3>
                                }
                            </div>
                        </div>

                        {/* graphic element for feedback box */}
                        <svg width="48" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.327 25.103 8.672 2.51h25.655v22.594Z" fill="#fff" stroke="#fff" strokeWidth="4"/><path d="m2 3 32 24M35 1l-.139 28" stroke="#1C75BC" strokeWidth="5"/></svg>
                    </div>
                </div>

                {/* form questions */}
                {this.props.feedback?.form_answers && this.props.feedback?.form_answers.length > 0 &&
                    <div className='card-body review-status border-bottom'>
                        <h4 className='mb-0'>
                            {__('Form Questions')}:&nbsp;
                        </h4>
                        <ul className='feedback-extras-questions-list'>
                            {this.props.feedback.form_answers.map((el, index) => (
                                <li key={index} className='feedback-extras-questions-list-item'>
                                    <span>{el.field}:</span>
                                    {el.option && <span>{el.option}</span>}
                                    {el.option_field && <span>{el.option_field}:</span>}
                                    <span>{el.value}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                }
                {/* recommended action */}
                {(!!this.props.feedback?.ratethisbizrating?.length  || !!this.props.feedback?.recommended_action?.length ) &&
                    <div className='card-body review-status border-bottom'>
                        <h4 className="mb-0"><strong>{__("Recommended action")}:</strong></h4>
                        <span>{this.props.feedback.recommended_action}</span>
                    </div>
                }

                {/* feedback details */}
                {this.props.feedback.tellmyco_id && this.props.feedback.geolocation && this.props.state.current_user && this.props.feedback.department && this.props.feedback.business.departments && this.props.feedback.business.departments.length == 1 &&
                    <div className="card-body review-status border-bottom satisfaction-metrics">
                        <div className="row detail-list ml-0 mr-0 mb-1">
                            {/* Location */}
                            {this.props.feedback.tellmyco_id
                                ?
                                <div className="col-md-4 col-sm-12 d-flex align-items-start">
                                    <div className="row py-0">
                                        <div className="col-12 pl-0">
                                            <p className="d-inline-block mb-0">
                                                <span>{__('Location')}: </span>
                                                <span> {this.props.feedback.tellmyco ? this.props.feedback.tellmyco.name : (this.props.feedback.business.nick_name ? this.props.feedback.business.nick_name : this.props.feedback.business.name + "(" + this.props.feedback.business.street_address + ")")}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                            }


                            <div className="col-md-4 col-sm-12 d-flex align-items-start">
                                {/* Geolocation */}
                                {(this.props.feedback.geolocation &&
                                    <div className="row">
                                        <div className="col-sm-12 pl-0">
                                            <p className="d-inline-block mb-0">
                                                <span>{__('Submitted Geolocation')}: </span>
                                                <a href={"https://maps.google.com/?q=" + this.props.feedback.geolocation.latitude + "," + this.props.feedback.geolocation.longitude} target="_blank">{this.props.feedback.geolocation.latitude.toFixed(5)}, {this.props.feedback.geolocation.longitude.toFixed(5)} - {__('Click to view map')}</a>
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="col-md-4 col-sm-12 d-flex align-items-center pl-0">
                                {this.props.state.current_user && this.props.feedback.department && this.props.feedback.business.departments && this.props.feedback.business.departments.length == 1 &&
                                    <p className="d-inline-block">
                                        <span>{__('Department')}:</span>
                                        <span> {this.props.feedback.department ? this.props.feedback.department.name : 'General'}</span>
                                    </p>
                                }
                            </div>

                        </div>
                    </div>
                }
            </>
        );
    }
}


function mapStateToProps(state) {
    return {
        alert: state.alert.alert,
        state: state,
        feedback: state.feedback_detail,
        employees: state.feedback_detail.department ? state.feedback_detail.department.users : state.feedback_detail.business.users
    }
}

export default connect(mapStateToProps)(FeedbackSection)
